import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutResponsibilityCodeList extends Layout {
    layoutheaderResponsibilityCodeList: LayoutHeader;
    sourceAgency: DataSource;
    tableResponsibilityCodes: Table;
}
